import { api } from '@/shared/lib/axios.ts';
import type {
  DeploySourceRow,
  DeploySourceCreated,
  DeploySourceListResponse,
  DeploySourceListParams,
} from '@/shared/types/deploy.ts';

export interface CreateDeploySourceDTO {
  workspace: string;
  repoSlug: string;
  nome: string;
  branches?: string;
  margemMinutos?: number;
  tenantIds: string[];
}

export interface UpdateDeploySourceDTO {
  nome?: string;
  branches?: string;
  margemMinutos?: number;
  tenantIds?: string[];
  isActive?: boolean;
}

export async function listDeploySources(
  params: DeploySourceListParams,
): Promise<DeploySourceListResponse> {
  const { data } = await api.get<DeploySourceListResponse>('/admin/deploy-sources', { params });
  return data;
}

export async function getDeploySource(id: string): Promise<DeploySourceRow> {
  const { data } = await api.get<DeploySourceRow>(`/admin/deploy-sources/${id}`);
  return data;
}

export async function createDeploySource(
  input: CreateDeploySourceDTO,
): Promise<DeploySourceCreated> {
  const { data } = await api.post<DeploySourceCreated>('/admin/deploy-sources', input);
  return data;
}

export async function updateDeploySource(
  id: string,
  input: UpdateDeploySourceDTO,
): Promise<DeploySourceRow> {
  const { data } = await api.put<DeploySourceRow>(`/admin/deploy-sources/${id}`, input);
  return data;
}

export async function rotateDeploySourceSecret(
  id: string,
): Promise<{ id: string; webhookSecret: string }> {
  const { data } = await api.post<{ id: string; webhookSecret: string }>(
    `/admin/deploy-sources/${id}/rotate-secret`,
  );
  return data;
}

export async function deleteDeploySource(id: string): Promise<DeploySourceRow> {
  const { data } = await api.delete<DeploySourceRow>(`/admin/deploy-sources/${id}`);
  return data;
}
